import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { Helmet } from 'react-helmet';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import BrowseTable from '../../components/BrowseTable/BrowseTable';
import { Link } from 'react-router-dom';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar';
import { Tag } from 'primereact/tag';

const BrowsePage = () => {

const navigate = useNavigate();
const location = useLocation();

useEffect(() => {
    if (!location.state) {
      navigate('/');
    }
}, [location.state, navigate]);

const state = location.state || [];
const initialData = state.data || [];
const filtersData = state.filters || [];
const [browseData, setBrowseData] = useState( initialData || []);
const [filters, setFilters] = useState( filtersData || []);

const itemsMap = {
   'unAnnNatVariants': 'UniProt Natural Variant',
   'clinicalSignificance': 'Clinvar Clinical significance',
    'consequence': 'Clinvar Consequence',
    'alphamissenseClass': 'Clinvar AlphaMissense class',
    'disease': 'Clinvar Disease',
    'unMoleculeProcessing': 'Molecule processing',
    'unLocation': 'Location',
    'unMotives': 'Motive',
    'unDomains': 'UniProt Domain',
    'interproDomain': 'InterPro Domain',
    'unLigandsBindingSite': 'Binding Site' ,
    'unAnnPropActiveSite': 'Active Site',
    'phosPtms': 'PTMs PhosphoSitePlus®',
    'unGlycosylations': 'Glycosylations',
     'unLipidations': 'Lipidations' ,
    'unModifiedRes': 'Modified Residue' ,
    'unDisulfideBongBridges': 'Disulfide Bond Bridges' ,
    'afConfidenceValue': 'pLDDT' ,
    'unCrossLinks': 'CrossLink' ,
    'inBindingRegion': 'IntAct Binding Region' ,
    'family': 'Protein Family' }

   const phosPtms =
      { 'p' :'Phosphorylation',
      'gl': 'Glycosylation' ,
      'ga': 'Glycation' ,
      'ub' : 'Ubiquitination' ,
      'ac': 'Acetylation',
      'm': 'Methylation' ,
       'sm'  : 'Sumoylation'
       }

  return (
    <>
      <Helmet>
      <title>Atlantis | Browse</title>
      </Helmet>
      <Header />
      <section className="px-5 py-10">
        <div className="container">
          <h1 className="display-5 fw-bold mb-5">Browse
          <sup>
                    <a href="/help/#browse" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                        <Button
                            icon="pi pi-info"
                            text
                            rounded
                            size="small"
                            className="btn-dialog"
                            tooltip="Learn Browse"
                        />
                    </a>
                  </sup>
          </h1>
          <h2 className="display-6 fw-bold title-explore mb-4">Search terms&nbsp;
           <img
                  alt="logo"
                  src="/assets/images/diagnosis.webp"
                  className="img-fluid btn-img"
                  style={{ verticalAlign: 'middle' }}
                />
          </h2>
          <div className="row mb-5">
           <div className="col-12">
            <div className="d-flex flex-wrap gap-2">
              {filters.map((f, idx) => (
                <Tag
                  key={idx}
                  severity="success"
                  className="p-2 fs--1"
                  value={`${itemsMap[f.key] || f.key}: ${
                    f.key === 'phosPtms'
                      ? String(f.value)
                          .split(',')
                          .map(code => phosPtms[code] ?? code)
                          .join(', ')
                      : f.value
                  }`}
                />
              ))}
            </div>
           </div>
          </div>
            <BrowseTable browseData={browseData} setBrowseData={setBrowseData} criteria={filters} />
        </div>
      </section>
      <Footer />
    </>
  );
};

export default BrowsePage;
